import { Box, Tab, Tabs } from "@mui/material";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { About } from "./About";
import { NewProposal } from "./NewProposal";
import { Proposals } from "./Proposals";

export const DaoComponent = () => {
  const { address } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const value = location.pathname.endsWith("/create")
    ? "/create"
    : location.pathname.endsWith("/about")
    ? "/about"
    : "/";

  return (
    <div>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={(e, path) => navigate(`/${address}${path}`)}
          aria-label="basic tabs example"
        >
          <Tab label="About" value="/about" />
          <Tab label="Proposals" value="/" />
          <Tab label="New Proposal" value="/create" />
        </Tabs>
      </Box>
      <Routes>
        <Route index element={<Proposals />} />
        <Route path="create" element={<NewProposal />} />
        <Route path="about" element={<About />} />
      </Routes>
    </div>
  );
};
